import React from "react";

import { BsChevronLeft } from "react-icons/bs";
import styled from "styled-components";

import { CancelButton, SubmitButton } from "shared/ui/buttons";

/**
 * 페이지형 등록/수정 폼의 공용 셸.
 *
 * 모든 폼이 공유하는 (1)상단 헤더(뒤로가기 < + 제목) (3)하단 버튼바(취소/제출)와
 * 로딩/에러 화면을 한 곳에 모은다. (2)본문은 도메인별로 children으로 주입한다.
 *
 * @param {string}  title        헤더 제목 (예: "회칙 - 자료 수정하기")
 * @param {()=>void} onBack      뒤로가기(<)·취소 핸들러
 * @param {boolean} isLoading    로딩 중이면 본문/버튼 대신 헤더만 표시
 * @param {string}  loadError    로드 실패 메시지(있으면 본문 대신 표시)
 * @param {string}  submitLabel  제출 버튼 라벨 (예: "수정하기")
 * @param {boolean} canSubmit    제출 버튼 활성화 여부
 * @param {()=>void} onSubmit    제출 핸들러
 * @param {()=>void} onCancel    취소 버튼 핸들러(기본값: onBack)
 * @param {string}  cancelLabel  취소 버튼 라벨(기본 "취소")
 */
export function FormPageShell({
  title,
  onBack,
  isLoading = false,
  loadError = "",
  submitLabel,
  canSubmit = false,
  onSubmit,
  onCancel,
  cancelLabel = "취소",
  children,
}) {
  const handleCancel = onCancel || onBack;

  return (
    <Page>
      <HeaderBar>
        <BsChevronLeft
          onClick={onBack}
          size={25}
          color="#00000080"
          strokeWidth="1"
          stroke="#00000080"
          style={{ cursor: "pointer" }}
        />
        <Title>{title}</Title>
      </HeaderBar>

      {isLoading ? null : loadError ? (
        <ErrorBox>{loadError}</ErrorBox>
      ) : (
        <>
          {children}
          <Footer>
            <CancelButton onClick={handleCancel} style={{ marginRight: "30px" }}>
              {cancelLabel}
            </CancelButton>
            <SubmitButton
              $active={canSubmit}
              disabled={!canSubmit}
              onClick={onSubmit}
            >
              {submitLabel}
            </SubmitButton>
          </Footer>
        </>
      )}
    </Page>
  );
}

export default FormPageShell;

const Page = styled.div`
  background: #f6f6f6;
  padding: 20px 40px;
  min-height: 100%;
  overflow-x: hidden;
`;

const HeaderBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 10px;
`;

const Title = styled.h2`
  color: #000;
  font-family: "NotoSansKRBold";
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: -1.8px;
  margin: 0;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding-bottom: 30px;
`;

const ErrorBox = styled.div`
  margin-top: 20px;
  padding: 20px;
  background: white;
  border-radius: 4px;
  font-family: "Noto Sans KR";
`;
